import React from 'react';
import Login from './Login'
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';

import { useTranslation } from 'react-i18next';

function isAuthenticated() {
    return !localStorage.getItem('jwt')
}    

function LoginContainer({match, history}) {

    const {t} = useTranslation();
    
    return (
        <div>
        {
            isAuthenticated() ? <React.Fragment>
                <div id="LogInContainer">
                    <div className="flex-left">
                    <Route path="/login" component={Login}/>
                    {/*<Route path="/register" component={Register}/>*/}
                    </div>
                    <div className="flex-right">
                    <div className="side-text">
                    <div className="side-text-big">
                            {t('EASY_ESIGNATURES')}
                        </div>
                        <br/>
                        <div className="side-text-big">
                            {t('TO_USE_WITH')}
                        </div>
                        <br/>
                        <div className="side-text-big">
                            {t('SECURITY')}
                        </div>
                        <br/>
                        <div className="side-text-small">
                            {t('WORK_FASTER')}
                        </div>
                    </div>
                    </div>
                </div>
            </React.Fragment> : <React.Fragment>
                <Redirect to={{
                    pathname:"/console/orgs"
                    }}/>     
                </React.Fragment>
        }
        </div>
    )
}

export default LoginContainer;